
import { SimulationConfig } from './types';

export const STORAGE_KEY = 'hypnotic_ball_config_v25';

export const DEFAULT_CONFIG: SimulationConfig = {
  mode: 'SPAWNER',
  gravity: 0.0375, restitution: 1, maxBalls: 400, initialBalls: 2,
  containerRadius: 187, containerLineWidth: 4, ballRadius: 2, ballMass: 1, spawnOnWallCollision: false,
  spawnOnBallCollision: true, rainbowMode: true, titleFontSize: 24,
  numOuterBorders: 1, rgbLighting: true, 
  
  // SHAPE DEFAULTS
  containerShape: 'CIRCLE',
  containerRotation: 0,
  ballShape: 'CIRCLE',
  ballRotationMode: 'VELOCITY',
  shapeMorphEnabled: false,
  shapeMorphSpeed: 1.0,
  shapeMorphDuration: 1000,
  shapeMorphContinuous: false,
  morphableShapes: [
      'CIRCLE', 'SQUARE', 'TRIANGLE', 'PENTAGON', 'HEXAGON', 'HEPTAGON', 'OCTAGON', 
      'NONAGON', 'DECAGON', 'STAR_5', 'STAR_6', 'STAR_8', 'HEART', 'DIAMOND', 
      'CROSS', 'CLOVER', 'FLOWER', 'SHIELD', 'INVERTED_TRIANGLE', 'GEM', 'GEAR'
  ],

  // GRANULAR VISUAL OVERRIDES
  useBallRGB: true,
  useTrailRGB: true,
  useContainerRGB: true,
  useFXRGB: true,
  useHUDRGB: true,
  
  renderOrder: ['WALLS', 'RINGS', 'TRAIL', 'BLAST', 'FX', 'BALL'],

  trailRGB: true, trailLength: 10,
  trailPersistence: false, // Default off
  spawnerTitle: "Spawner Mode: Collide to Multiply",
  drawerTitle: "Drawer Mode: Collide to Grow & Draw",
  trailTitle: "Trail Mode: Collide to Leave Echoes",
  escapeTitle: "Escape Mode: Pass Gaps to Destroy Rings",
  rhythmicTitle: "Rhythm Mode: Physics Sync",
  darkMode: false, selectedMelody: 'Megalovania',
  growthRate: 0.05,
  trailInterval: 100,
  trailOpacity: 0.4,
  trailWidthMultiplier: 1.0,
  trailStartScale: 0.4,
  trailEndScale: 1.0,
  trailGlowAmount: 0,
  trailCustomColor: '#ffffff',
  
  // NEW TRAIL FEATURES
  trailStrokeColor: '#000000',
  trailStrokeWidth: 2, // Default visible black border
  
  // DYNAMICS
  speedIncreaseMode: 'STATIC',
  speedIncreaseRate: 0.005,
  initialSpeed: 1.0,
  masterSpeed: 1.0,

  ballGrowthMode: 'NONE',
  ballGrowthRate: 0.5,
  ballMaxRadius: 100,
  
  containerShrinkMode: 'NONE', // NEW
  containerShrinkRate: 0.5, // NEW
  minContainerRadius: 50, // NEW

  // RHYTHMIC DEFAULTS
  rhythmicTimeScale: 1.0,
  rhythmicCircleScale: 1.0,

  // INDIVIDUAL COLORS
  ballColor: '#3b82f6',
  ball1Color: '#ef4444', 
  ball2Color: '#3b82f6', 
  borderColor: '#1a1a1a',
  innerColor: '#ffffff',
  outerColor: '#f5f5dc',
  titleColor: '#171717',
  collisionWaveColor: '#3b82f6',
  blastColor: '#ef4444',
  
  footerText: "Hypnotic Audio-Visual Experience",
  footerTextColor: '#171717',
  footerFontSize: 20,
  audioTrailEffect: false,
  audioEcho: true,
  ballCollisionSoundType: 'MELODY',
  selectedBallSoundEffect: 'Pop',
  breakSoundType: 'SOUND_EFFECT',
  selectedBreakSoundEffect: 'Explosion',
  drawerReverseMode: false,
  drawerMinRadius: 15,
  escapeRingCount: 100, 
  escapeGapSize: 30,
  escapeRotationSpeed: 1.5,
  escapeGapAlignment: 'ALIGNED',
  escapeShrinkMode: true,
  escapeStaticMode: false,
  escapeShrinkRate: 0.5,
  escapeRotationMode: 'CLOCKWISE',
  escapeRingSpacing: 40,
  escapeStopRotationOnHit: false,
  escapeDynamicShrink: false,
  escapeMinRadius: 0, 
  escapeBreakAnimation: 'SHATTER',
  escapeShowOuterBorders: false,
  ringCounterStyle: 'CENTER',
  ringCounterFontSize: 180,
  escapeTimerFontSize: 220,
  timerColor: '#ffffff',
  escapeFixedGapDirection: 90,
  escapeSideGuards: false, // DEFAULT OFF
  
  escapeAccelerationEnabled: false,
  escapeAccelerationMultiplier: 0.1,
  escapeAccelerationDecay: 0.02,
  escapeAccelerationMax: 3.0,
  
  escapeOppositeGapCount: 0,
  escapeOppositeGapSize: 30,
  ringCounterReverse: false,

  // HUD DEFAULTS
  ringCounterFont: 'Inter, sans-serif',
  ringCounterFontWeight: '900',
  ringCounterColor: '#ffffff',
  ringCounterStrokeColor: '#000000',
  ringCounterStrokeWidth: 0,
  ringCounterOpacity: 0.4,
  ringCounterUseRGB: true,
  ringCounterUseRGBBorder: false, // DEFAULT OFF SO USER CAN EDIT COLOR
  ringCounterShadowBlur: 0,
  ringCounterShadowColor: '#000000',

  ballStyle: 'SHINY',
  escapeThrowAngle: 270,
  escapeThrowPower: 22,
  escapeTimeChallengeMode: false,
  escapeTimerStart: 10,
  escapeTimeAddition: 5,
  escapeTimeAdditionStep: -0.1,
  audioCropStart: 0,
  audioCropEnd: 100,
  customMelodies: [],
  fxPresets: [],
  userSounds: [],

  // BREAK SOUND ZONES
  enableBreakSoundZones: false,
  breakSoundZones: [],

  // CAMERA DEFAULTS
  cameraFollow: false,
  cameraSmoothness: 0.08,
  cameraLookahead: 5.0,
  cameraDeadzone: 20.0,
  cameraZoom: 1.0,

  // HUD
  ringCounterPosition: 'CENTER',
  ringCounterOffset: -40,

  // COLLISION EFFECTS (IMPACT FX)
  collisionEffect: 'GRAVITY_PARTICLES',
  collisionEffectDuration: 800,
  collisionEffectParticleCount: 20,
  collisionEffectGravity: 0.5,
  collisionEffectColorMode: 'BALL_COLOR',
  collisionEffectColor1: '#ff0000',
  collisionEffectColor2: '#ffff00',

  // ADVANCED DEFAULTS
  physicsSubsteps: 4,
  airResistance: 0.999,
  hueCycleSpeed: 0.8,
  shakeIntensityMultiplier: 1.0,
  shakeDecayRate: 0.92,
  popDecayRate: 0.05,
  escapeRingAlphaBase: 1.0,
  escapeRingAlphaFade: 1.0,
  escapeRingThickness: 4,
  escapeMaxVisibleRings: 450,
  maxVelocityLimit: 22,
  minVelocityLimit: 7.5,
  antiStallMultiplier: 1.0,
  drawerLineThickness: 1,
  drawerLineOpacity: 0.2,
  blastDuration: 4000, 
  collisionVolume: 0.5,
  melodyVolume: 0.6,
  masterVolume: 1.0,
  fxVolume: 0.8,

  // MELODY RACK DEFAULTS
  melodyInstrument: 'GRAND_PIANO',
  melodyWaveform: 'AUTO',
  audioReverbLevel: 0.15,
  audioDistortionLevel: 0,
  audioLowPassFreq: 12000,
  audioLowPassResonance: 1.0,
  audioDelayTime: 0.35,
  audioDelayFeedback: 0.45,
  audioEchoWet: 0.5,
  audioEchoStereoWidth: 0.7,
  
  // FX RACK DEFAULTS
  fxReverbLevel: 0.1,
  fxDistortionLevel: 0,
  fxLowPassFreq: 20000,
  fxLowPassResonance: 1.0,
  fxEcho: true,
  fxDelayTime: 0.2,
  fxDelayFeedback: 0.3,
  fxEchoWet: 0.4,
  
  audioCompoundMode: false,

  // SHARED AUDIO DEFAULTS
  audioHighPassFreq: 20,
  audioBitcrushDepth: 16,
  audioPitchShift: 0,
  audioChorus: false,
  audioChorusRate: 1.5,
  audioChorusDepth: 0.002,
  audioFlanger: false,
  audioFlangerRate: 0.25,
  audioFlangerDepth: 0.004,
  audioPhaser: false,
  audioPhaserRate: 0.5,
  audioPhaserDepth: 0.5,
  audioTremolo: false,
  audioTremoloRate: 5.0,
  audioTremoloDepth: 0.5,
  audioVibrato: false,
  audioVibratoRate: 5.0,
  audioVibratoDepth: 0.5,
  audioCompressor: true,
  audioCompThreshold: -12,
  audioCompRatio: 4,
  audioReverbPreDelay: 0.01,
  audioBitcrushFreq: 44100,
  escapeSpiralTightness: 0.15,

  // SLIDING AUDIO DEFAULTS
  audioSlidingEnabled: true,
  audioSlidingMaxSpeed: 50,
  audioSlidingVolume: 0.3,
  audioSlidingPitch: 1.0,
  
  // RING COLOR SETTINGS
  escapeColorMode: 'RAINBOW',
  escapeUniformColor: '#3b82f6',
  escapeColorA: '#ff0000',
  escapeColorB: '#ffffff',

  // SPHERE STUDIO DEFAULTS
  ballFillType: 'SOLID',
  ballFillOpacity: 1.0,
  ballGradientInner: '#ffffff',
  ballGradientOuter: '#000000',
  ballStrokeColor: '#ffffff',
  ballStrokeWidth: 0,
  ballStrokeOpacity: 1.0,
  ballGlowRadius: 0,
  ballGlowColor: '#ffffff',
  ballGlowOpacity: 0.5,
  ballTexture: 'NONE',
  ballTextureOpacity: 0.2,
  ballSquashStretch: false,
  ballSquashFactor: 0.5,
  ballPulseSpeed: 0,

  // SONG SLICE MODE
  songSliceDuration: 0.15,

  // SHATTER FX
  shatterForce: 100,
  shatterGravity: 500,

  // OPTIMIZATION DEFAULTS
  dustResolution: 0.5,
  maxDustParticles: 100,
  maxActiveBlasts: 200 
};
